export default "__VITE_ASSET__c34f99c2__"